<!-- 确认商品 -->
<template>
  <div class="backgroundGrey base-padding">
    <div class="applyItem">
      <div class="details-title">
        航班信息
      </div>
      <div>
        <span>航班日期：</span>
        <span>{{ main.flightDate }}</span>
      </div>
      <div>
        <span>航线环：</span>
        <span>{{ main.flightNoRing }}</span>
      </div>
      <div>
        <span>航段环：</span>
        <span>{{ main.flightLineRing }}</span>
      </div>
    </div>
    <div class="details-card" style="padding: 0">
      <van-form>
        <van-field readonly clickable label="城市" :value="cityName" placeholder="选择城市" input-align="right" right-icon="arrow" @click="showPicker = true" />
      </van-form>
    </div>
    <div class="details-card">
      <div class="details-title">
        商品信息
      </div>
      <Grid :columns="columns" :tableData="selectedList" />
    </div>
    <div style="height: 60px"></div>
    <div class="bottom-box">
      <div>已选 <span style="color:#e1514c">{{ amountNumber }}</span> 件，共计¥<span style="color:#e1514c">{{ amountPrice }}</span> </div>
      <van-button type="primary" class="bottom-button" @click="submit" size="small">提交申请</van-button>
    </div>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker show-toolbar :columns="piColumns" @cancel="showPicker = false" @confirm="onConfirm" />
    </van-popup>
  </div>
</template>

<script>
import Grid from '@/components/common/Grid/index.vue'

export default {
  components: {
    Grid,
  },
  data() {
    return {
      cityName: '',
      main: {},
      columns: [
        { label: '商品名称', prop: 'name' },
        { label: '规格', prop: 'sku' },
        { label: '售价', prop: 'salesPrice' },
        { label: '申请数量', prop: 'number' },
      ],
      selectedList: [],
      amountNumber: 0,
      amountPrice: 0,
      showPicker: false,
      piColumns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],
    }
  },
  activated() {
    this.main = this.$route.query
    this.selectedList = this.$route.params.selectedList
    this.amountNumber = this.$route.params.amountNumber
    this.amountPrice = this.$route.params.amountPrice
    this.getCityList()
  },
  methods: {
    onConfirm(v) {
      this.cityName = v
      this.main.tbBasicCityId = this.cityList.filter(i => i.name === this.cityName)[0].id
      this.showPicker = false
    },
    submit() {
      if (this.main.applyNo) {
        this.apply(this.main.applyNo)
      } else {
        // 第一次提交先获取单号
        this.$api.get('/api-sys/sell/sellAddMatterWF/getOrderNo').then((res) => {
          if (res.code === '0000') {
            this.apply(res.data)
          }
        })
      }
    },
    getCityList() {
      // 第一次提交先获取单号
        this.$api.get('/api-sys/sell/sellAddMatterWF/getCityByPage').then((res) => {
          if (res.code === '0000') {
            this.cityList = res.data
            this.piColumns = this.cityList.map(i => i.name)
            this.cityName = this.cityList.filter(i => i.id === this.main.tbBasicCityId)[0].name
          }
        })
    },
    apply(applyNo) {
      let params = {
        applyNo: applyNo,
        staffId: this.$store.state.userInfo.userId,
        companyId: this.$store.state.userInfo.companyId,
        ...this.main,
        cityId: this.main.tbBasicCityId,
        details: this.selectedList.map((item) => {
          return {
            productId: item.id,
            quantity: item.number,
          }
        }),
      }
      // 判断是否驳回二次提交
      let url = this.main.applyNo ? '/api-sys/sell/sellAddMatterWF/submit' : '/api-sys/sell/sellAddMatterWF/apply'
      this.$api.post(url, params).then((res) => {
        if (res.code === '0000') {
          this.$Toast.success('操作成功')
          setTimeout(() => {
            this.$utils.routerPush({
              name: 'DistributionApplication',
            })
          }, 700)
        }
      })
    },
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/view/DistributionApplication/ConfirmProduct.vue